import { PayloadType } from 'APP/model/message/messageModel.types';
import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

const allowedTypes = [
  PayloadType.RichText,
  PayloadType.Video,
  PayloadType.Image,
  PayloadType.Album,
  PayloadType.Sticker,
  PayloadType.Location,
  PayloadType.VoiceMessage,
  PayloadType.File,
  PayloadType.Contact,
  PayloadType.ButtonsSelected,
  PayloadType.AudioMessage,
  PayloadType.Article,
  PayloadType.SystemStream,
  PayloadType.Advertisement,
  PayloadType.Buttons,
  PayloadType.E2ee,
];

const editableTypes = [
  PayloadType.RichText,
  PayloadType.Video,
  PayloadType.Image,
  PayloadType.Album,
  PayloadType.Article,
  PayloadType.File,
  PayloadType.AudioMessage,
  PayloadType.VoiceMessage,
  PayloadType.E2ee,
];

export const isMessageCanBeEdit = (message: ChatMessage): boolean => {
  if (message.group?.isSecretGroup && message.payload.payloadType !== PayloadType.E2ee) {
    return false;
  }

  if (!editableTypes.includes(message.payload.payloadType) || message.forward) {
    return false;
  }

  if (message.payload.payloadType === PayloadType.Article && !Features.isArticleEnabled()) {
    return false;
  }

  if (!message.fromMe) {
    return false;
  }

  if (message.group?.isChatGroup) {
    return !message.group.withoutMe;
  }

  return true;
};

export const isMessageCanBeReplied = (message: ChatMessage): boolean => {
  return (
    !Entities.ChatStore.isDisableToWrite &&
    allowedTypes.includes(message.payload.payloadType) &&
    !message.isFake
  );
};

export const isMessageCanBeQuoted = (message: ChatMessage, isForward?: boolean): boolean => {
  if (!isForward && Entities.ChatStore.isDisableToWrite) {
    return false;
  }
  return allowedTypes.includes(message.payload.payloadType) && !message.isFake;
};

export const isMessageCanBeForward = (message: ChatMessage): boolean => {
  return (
    !message.isFake &&
    !!message.senderUser &&
    message.payload.payloadType !== PayloadType.ButtonsSelected &&
    message.payload.payloadType !== PayloadType.Advertisement
  );
};

export const isMessageCanBeAddedToCollection = (message: ChatMessage): boolean => {
  const {
    group,
    payload: { payloadType },
  } = message;

  const invalidPayloadType = [PayloadType.AudioMessage, PayloadType.VoiceMessage, PayloadType.File];

  return Boolean(
    group?.spaceId &&
      !message.isFake &&
      !message.payload.isSystem &&
      Entities.spacesStore.getById(group?.spaceId)?.isOwner &&
      (group.isChatGroup || group.isChannel) &&
      !invalidPayloadType.includes(payloadType)
  );
};
